import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import FormatService from '../../../services/format-service';
import { DATA_CONTACT_ID, DATA_TAG_ID } from '../../../constants/system/data-attributes';
import { QUERY_PARAM_TAG_ID } from '../../../constants/system/query-params';
import { HTML_TAG_NAME_ANCHOR } from '../../../constants/system/html-tag-names';

class MentionUserLinks extends Plugin {
  init(): void {
    const MENTION_LINK_PRIORITY_DEFAULT: number = 20;
    const CONVERTER_PRIORITY_HIGH: string = 'high';
    const ATTRIBUTE_DATA_MENTION: string = 'data-mention';
    const ATTRIBUTE_HREF: string = 'href';
    const TARGET_BLANK: string = '_blank';
    const EVENT_NAME_UPCAST: string = 'upcast';
    const EVENT_NAME_DOWNCAST: string = 'downcast';
    const MODEL_NAME_MENTION: string = 'mention';
    const CLASS_NAME_MENTION: string = 'mention';
    const PLUGIN_NAME_MENTION: string = 'Mention';

    const editor: CKEditorInstance = this.editor;
    const options: CKEditorPluginOptions = editor.config.get('mentionUserLinks');
    const mentionRouteRoot: string | null = options.mentionRouteRoot || null;
    const hashtagRouteRoot: string | null = options.hashtagRouteRoot || null;

    editor.conversion.for(EVENT_NAME_UPCAST).elementToAttribute({
      view: {
        name: HTML_TAG_NAME_ANCHOR,
        key: ATTRIBUTE_DATA_MENTION,
        classes: MODEL_NAME_MENTION,
        attributes: {
          href: true,
          target: true,
          [DATA_CONTACT_ID]: true,
          [DATA_TAG_ID]: true,
        },
      },
      model: {
        key: MODEL_NAME_MENTION,
        value: (viewItem: ViewItem): ViewItemAttributes | null => {
          if (!viewItem) {
            return null;
          }

          return editor.plugins.get(PLUGIN_NAME_MENTION).toMentionAttribute(viewItem, {
            link: viewItem.getAttribute(ATTRIBUTE_HREF),
            contactId: viewItem.getAttribute(DATA_CONTACT_ID) || null,
            tagId: viewItem.getAttribute(DATA_TAG_ID) || null,
          });
        },
      },
      converterPriority: CONVERTER_PRIORITY_HIGH,
    });

    editor.conversion.for(EVENT_NAME_DOWNCAST).attributeToElement({
      model: MODEL_NAME_MENTION,
      view: (mentionItem: ViewItem, { writer }: ViewItemOptions): HTMLElement | null => {
        if (!mentionItem) {
          return null;
        }

        const attributes: ViewItemAttributes = {
          class: CLASS_NAME_MENTION,
          target: TARGET_BLANK,
          [DATA_CONTACT_ID]: mentionItem.contactId || '',
          [DATA_TAG_ID]: mentionItem.tagId || '',
        };

        if (mentionItem.contactId && mentionRouteRoot) {
          attributes.href = `${mentionRouteRoot}/${mentionItem.contactId}`;
        }

        if (mentionItem.tagId && hashtagRouteRoot) {
          const queryParams: LocationQueryParams = {
            [QUERY_PARAM_TAG_ID]: mentionItem.tagId,
          };

          attributes.href = `${hashtagRouteRoot}${FormatService.formatQueryParams(queryParams)}`;
        }

        return writer.createAttributeElement(HTML_TAG_NAME_ANCHOR, attributes, {
          id: mentionItem.id,
          priority: MENTION_LINK_PRIORITY_DEFAULT,
        });
      },
      converterPriority: CONVERTER_PRIORITY_HIGH,
    });
  }
}

export default MentionUserLinks;
